import CloseIcon from '@mui/icons-material/Close';
import { Box, Card, CardContent, IconButton, Stack } from '@mui/material';
import _ from 'lodash';
import useResponsive from '../../hooks/useResponsive';
import {
  PrimaryLoadingButton,
  PrimaryOutlinedButton,
} from '../style/ButtonStyle';
import { FormTitle } from '../style/TextStyle';
import { CenterModal, ModalHeader } from './Modal';
export function FormModal({
  on = false,
  title = '',
  children = <></>,
  onClose = _.noop,
  loading = false,
  onConfirm = _.noop,
  confirmText = '확인',
  cancelText = '취소',
}) {
  const smUp = useResponsive('up', 'sm');
  return (
    <>
      <CenterModal open={on} onClose={onClose}>
        <Card
          sx={{
            minWidth: { xs: 310, sm: 450, md: 670 },
            borderRadius: '20px',
            p: { sm: 2 },
          }}
        >
          {smUp ? (
            <ModalHeader justifyContent="space-between">
              <FormTitle>{title}</FormTitle>
              <IconButton size="small" onClick={onClose}>
                <CloseIcon sx={{ width: 20, height: 20 }} />
              </IconButton>
            </ModalHeader>
          ) : (
            <ModalHeader justifyContent="center">
              <FormTitle>{title}</FormTitle>
            </ModalHeader>
          )}
          <CardContent>
            {children}
            <Stack direction="row" justifyContent="space-between" mt={3}>
              <Box />
              <Stack direction="row" spacing={1}>
                <PrimaryOutlinedButton
                  onClick={onClose}
                  sx={{ width: { md: 140 } }}
                >
                  {cancelText}
                </PrimaryOutlinedButton>
                <PrimaryLoadingButton
                  loading={loading}
                  onClick={onConfirm}
                  sx={{ width: { md: 140 } }}
                >
                  {confirmText}
                </PrimaryLoadingButton>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </CenterModal>
    </>
  );
}
